export default __webpack_public_path__ + "static/media/payment-jcb.19f78dfe.svg";